<template>
    <div class="nrk">
        <div class="news">
                <div class="news-left wow animate__animated animate__fadeInLeft" @click="News">
                    <div class="news-left-img">
                        <img src="./img/tu8.jpg">
                        <div class="news-left-text">
                            企业简介
                        </div>
                    </div>
                    <div class="news-left-nr">
                        <a href="#"> 
                            <p>欢迎惠顾吉林医药设计院有限公司网站！</p>
                            <div> 吉林医药设计院有限公司（以下简称吉林医药设计院）创建于1986年，民营企业,中国医药工程设计协会副会长单位，吉林省勘察设计行业AAA级信用企业。拥有一批经验丰富的优秀工程设计人员，......
                                <span>查看全部 ></span>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="news-left wow animate__animated animate__fadeInLeft news-leftld"  @click="Addls">
                    <div class="news-left-img">
                        <img src="./img/tu9.jpg">
                        <div class="news-left-text">
                            院长致辞
                        </div>
                    </div>
                    <div class="news-left-nr">
                        <a>
                            <p>欢迎惠顾吉林医药设计院有限公司网站！</p>
                            <div>吉林医药设计院有限公司是中国医药工程设计协会副会长单位，具有国家住房和城乡建设部批准的化工、石化、医药行业甲级设计资质，国家发展和改革委员会批准的甲级工程咨询资质......
                                <span>查看全部 ></span>
                            </div>
                            <!-- <p class="news-left-time">
                                <img src="./img/xt_2.png" class="xt-2">
                                <i>2018-11-22</i>
                            </p> -->
                        </a>
                    </div>
                </div>
                <div class="news-left news-tab-bj wow animate__animated animate__fadeInLeft news-leftld">
                    <ul class="news-tab">
                        <li :class="index==lnt?'news-tab-click':''" 
                        v-for="(item,index) in nametab" :key="index"
                        @mouseover='lieb(index)'
                        >
                        {{item.name}}
                        </li>
                    </ul>
                    <ul class="news-tab-son">
                        <li v-for="item in Newsname.data" :key="item.id" @click="Details(item.id)">
                            <div class="news-content">
                                <a>
                                <i>{{item.title}}</i>
                                <div>
                                    <img src="./img/xt_2.png" class="xt-2">
                                    <span>{{item.push_time}}</span>
                                </div>
                                </a>
                            </div>
                        </li>
                        <a @click="NewsJump">
                            <div class="news-more">查看更多></div>
                        </a>
                    </ul>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            lnt:0,
            nametab:[
                {id:1,name:'新闻中心'},
                {id:4,name:'行业动态'},
                {id:5,name:'法律法规'}
            ]
        }
    },
    props:['Newsname','NewsNav'],
    methods: {
        Addls(){
            this.$router.push({name:'Address'})
        },
        News(){
            this.$router.push({name:'Company'})
        },
        lieb(index){
            this.lnt=index
            this.$emit('Newslieb',this.nametab[index].id)
        },
        NewsJump(){
            let url=this.NewsNav[this.lnt+1].url
            this.$router.push({
                name:url,
            })
        },
        Details(id){
            this.$router.push({
                name:'NewsDetails',
                    query:{
                        id:id,
            }
        })
      },
    },
}
</script>

<style scoped>
    a:hover{
        text-decoration:none;
    }
    .news {
        width: 100%;
        margin: 0 auto;
        padding: 10px;
        overflow: hidden;
        margin-top: 4%;
    }

    .news-left {
        float: left;
        width: 480px;
        height: 520px;
        box-shadow: 0px 0px 5px #d9d9d9;
        overflow: hidden;
        cursor: pointer;
    }
    .news-leftld{
        margin-left: 30px;
    }
    .news-left-img {
        position: relative;
    }

    .news-left-img img {
        width: 100%;
        height: 320px;
    }

    .liedqn {
        position: absolute;
        top: 300px;
        right: 16px;
        font-size: 18px;
        color: #3dabed;
    }
    .news-tab-bj{
        background-color: #f6f6f6;;
    }
    .news-tab{
        width: 100%;
        height: 50px;
        background-color: #fff;
    }
    .news-tab li{
        float: left;
        width: 33.3%;
        background-color: #fff;
        text-align: center;
        line-height: 50px;
        font-size: 18px;
        cursor: pointer;
    }
    .news-tab .news-tab-click{
        background-color: #0082e4; /* 针对不支持渐变的浏览器 */
        background-image: linear-gradient(to right, #008df1 , #0d1f61);
        color: #fff;
    }
    .news-left-text {
        width: 183px;
        height: 58px;
        text-align: center;
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        line-height: 58px;
        background-color: #000;
        /* 不支持线性的时候显示 */
        background-image: linear-gradient(to right, #0385fb, #09014f);
        font-size: 20px;
        z-index: 1;
    }

    .news-left-nr {
        width: 88%;
        margin: 0 auto;
        margin-top: 23px;
    }

    .news-left-nr p {
        font-size: 20px;
        font-weight: bold;
    }

    .news-left-nr div {
        font-size: 12px;
        color: #666;
        width: 100%;
        text-align: justify;
        margin-top: 24px;
        text-indent: 2em;
        line-height: 22px;
    }

    .news-left-nr div span {
        color: #0086d1;
    }

    .news-folird {
        float: right;
        position: relative;
    }

    .news-left-ul {
        position: relative;
        width: 1620px;
    }

    .news-left-ul li {
        float: left;
        width: 540px;
        overflow: hidden;
        position: relative;
    }
    .news-left-time img {
        width: 16px;
        height: 16px;
        float: left;
    }
    .news-content a{
    width: 90%;
    padding: 18px 5% 18px 5%;
    display: block;
    }
    .news-content i{
        font-size: 16px;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp:1;
        -webkit-box-orient: vertical;
        color: #333;
    }
    .news-content div{
        margin-top: 8px;
        overflow: hidden;
        padding-left: 2%;
    }
    .news-content:hover{
        background-color: #fff;
    }
    .news-content:hover i{
        background-color: #fff;
        background-image: linear-gradient(to right, #0083f1, #120f3e); /* 线性渐变背景，方向向上 */
        -webkit-background-clip: text; /* 背景被裁剪成文字的前景色 */
        -webkit-text-fill-color: transparent; /* 文字填充颜色变透明 */   

    }
    .news-content .xt-2 {
        float: left;
        width: 16px;
        height: 16px;
        margin-right: 6px;
    }
    .news-more {
        width: 100%;
        height: 50px;
        line-height: 45px;
        color: #0081f0;
        text-align: center;
        font-size: 14px;
    }
    .news-left-time img {
        width: 16px;
        height: 16px;
        float: left;
    }
    .news-left-time i {
        font-size: 12px;
        font-weight: normal;
        float: left;
        margin-left: 4px;
        color: #999;
    }
    .news-left-time {
        float: right;
        padding: 0;
    }
    @media (max-width: 768px){
        .news-left-nr p{
            font-size: 18px;
        }
        .news{
            padding: 0px;
        }
        .news-left-img img{
            height: auto;
        }
        .news-left{
            width: 98%;
            margin: 0 auto;
            height: auto;
            padding-bottom: 12px;
            margin-bottom: 24px;
        }
        .news-left-text{
            width: 160px;
            height: 48px;
            line-height: 48px;
            font-size: 18px;
        }
        .news-left-nr div{
            margin-top: 8px;
        }
        .news-content a{
            padding: 10 px 5% 10px 5%;
        }
    }
</style>